__turbopack_context__.v({
  "requisitesLink": "main-menu-mobile-module-scss-module__8S_E5G__requisitesLink",
});
